import Svg from '@material-symbols/svg-400/outlined/arrow_downward.svg'
import { type SvgIconProps } from '@mui/material'
import { MaterialSymbol } from './MaterialSymbol'

export function ArrowDownwardIcon(props: SvgIconProps) {
  return <MaterialSymbol icon={Svg} {...props} />
}
